module.exports = __webpack_public_path__ + "static/img/cstp2.c7511ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/cstp2.png
// module id = jj+4
// module chunks = 1